import styled from "styled-components";

import Tag from "ds/Tag";

export const AdminTagWrapper = styled(Tag)`
  padding: 2px 8px 2px 4px;
`;
